import { Link } from 'react-router-dom';

interface MidPageCTAProps {
  headline?: string;
  subtext?: string;
}

export default function MidPageCTA({
  headline = 'Need Environmental Remediation or Emergency Response?',
  subtext = 'Certified specialists available 24/7. Get a free assessment and project-specific quote.',
}: MidPageCTAProps) {
  return (
    <div className="bg-ecos-green-deep py-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-5">
          <div className="w-12 h-12 flex items-center justify-center bg-white/15 rounded-sm flex-shrink-0">
            <i className="ri-alarm-warning-line text-white text-2xl"></i>
          </div>
          <div>
            <p className="text-white font-semibold text-base leading-snug">{headline}</p>
            <p className="text-white/65 text-sm mt-0.5">{subtext}</p>
          </div>
        </div>
        <div className="flex items-center gap-4 flex-shrink-0">
          <a
            href="tel:+18888685420"
            className="inline-flex items-center gap-2 border border-white/30 hover:border-white text-white px-5 py-2.5 rounded-sm text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill text-sm"></i>
            888-868-5420
          </a>
          <Link
            to="/#assessment"
            className="inline-flex items-center gap-2 bg-white text-ecos-green-deep hover:bg-ecos-slate px-5 py-2.5 rounded-sm text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            Free Assessment
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}
